import { Component, Input, OnDestroy, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { Modal } from 'bootstrap';

import { QuestionService } from './question-dialog.service';

@Component({
	selector: 'app-question-dialog',
	templateUrl: './question-dialog.component.html',
	styleUrls: ['./question-dialog.component.css'],
})
export class QuestionDialogComponent implements OnChanges, OnInit, OnDestroy {
	@Input() id: string = null;
	@Input() question = '';
	@Input() dialogId = 'questionModal';

	serviceSubscribtion;

	constructor(private readonly questionService: QuestionService) {}

	ngOnChanges(changes: SimpleChanges) {
		if (!this.question) {
			return;
		}
		if (!changes.question) {
			return;
		}
		if (changes.question.currentValue == changes.question.previousValue) {
			return;
		}
		this.dialogOpen();
	}

	ngOnInit(): void {
		this.serviceSubscribtion = this.questionService.dialogStatus.subscribe((data) => {
			this.question = data;
			this.dialogOpen();
		});
	}

	ngOnDestroy(): void {
		this.serviceSubscribtion.unsubscribe();
	}

	dialogOnYes(): void {
		this.dialogClose();
		this.questionService.returnResult(true);
	}

	dialogOnNo(): void {
		this.question = null;
		this.dialogClose();
		this.questionService.returnResult(false);
	}

	private dialogOpen(): void {
		new Modal(document.getElementById('questionModal')).show();
	}

	private dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('questionModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}
}
